import React from 'react';
import { ReturnedValue } from 'use-sound/dist/types';
import { CharacterSeed } from '../views/avatar/Avatar';

export type Sounds =
    | 'play-background-music'
    | 'stop-background-music'
    | 'level-down-background-music'
    | 'level-up-background-music'
    | 'play-login-intro'
    | 'stop-login-intro'
    | 'play-avatar-music'
    | 'stop-avatar-music'
    | 'play-cuenca-baja-intro'
    | 'stop-cuenca-baja-intro'
    | 'play-cuenca-media-intro'
    | 'stop-cuenca-media-intro'
    | 'play-cuenca-alta-intro'
    | 'stop-cuenca-alta-intro'
    | 'play-glaciar-intro'
    | 'stop-glaciar-intro'
    | 'play-pop-effect'
    | 'play-success-effect'
    | 'play-fail-effect'
    | 'play-victory-effect';

export interface GameState {
    singlePlayerGameState: SinglePlayerGameState;
    multiPlayerGameState: MultiPlayerGameState;
    avatarSeed: CharacterSeed;
    playerName: string;
    handleSetAvatar: (seed: CharacterSeed) => void;
    handleSetPlayerName: (name: string) => void;
    handleSetPlayerScore: (score: number) => void;
    handleMainSound: (action: Sounds) => void;
    handleDialogSound: null | {
        [key: string]: ReturnedValue;
    };
}

export interface SinglePlayerGameState {
    score: number;
}

export interface MultiPlayerGameState {}

export const defaultGameState: GameState = {
    singlePlayerGameState: {
        score: 0,
    },
    multiPlayerGameState: {},
    avatarSeed: {
        color: 'white',
        genre: 'male',
        skin: 'nature',
    },
    playerName: 'héroe' + Math.floor(1000 + Math.random() * 9000),
    handleSetAvatar: () => null,
    handleSetPlayerName: () => null,
    handleSetPlayerScore: () => null,
    handleMainSound: () => null,
    handleDialogSound: null,
};

export const defaultMultiPlayerGameState = {};

const GameContext = React.createContext<GameState>(defaultGameState);

export default GameContext;
